<template>
  <span class="health-reviewed-line">
    <template v-if="loaded">
      <template v-if="reviewedDt">
        ทบทวนล่าสุด {{ text }}<template v-if="showDaysAgo">
          ({{ daysAgo }} วันก่อน)</template
        >
      </template>
      <template v-else>ยังไม่เคยทบทวน</template>
    </template>
  </span>
</template>

<script>
import moment from "moment";
import { stampText } from "@/utils/healthReview";

/**
 * "ทบทวนล่าสุด <date time> โดย <name>": the patient's latest per-visit health
 * review. Uses healthReviewedDt/U when the patient came from GET /patient;
 * patients taken from appointment rows don't carry them, so it fetches once.
 */
export default {
  name: "HealthReviewedLine",
  props: {
    patient: { type: Object, required: true },
    showDaysAgo: { type: Boolean, default: false },
  },
  data() {
    return { fetched: null };
  },
  computed: {
    hasOwn() {
      return this.patient && "healthReviewedDt" in this.patient;
    },
    source() {
      return this.hasOwn ? this.patient : this.fetched;
    },
    loaded() {
      return !!this.source;
    },
    reviewedDt() {
      return this.source?.healthReviewedDt || null;
    },
    text() {
      return stampText(this.reviewedDt, this.source?.healthReviewedU);
    },
    daysAgo() {
      return moment()
        .startOf("day")
        .diff(moment(this.reviewedDt).startOf("day"), "days");
    },
  },
  watch: {
    "patient.id": {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      this.fetched = null;
      if (this.hasOwn || !this.patient?.id) return;
      const id = this.patient.id;
      try {
        const res = await this.$store.dispatch("modulePatient/fetchPatientById", {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id,
        });
        if (this.patient?.id !== id) return;
        this.fetched = {
          healthReviewedDt: res?.data?.healthReviewedDt || null,
          healthReviewedU: res?.data?.healthReviewedU || null,
        };
      } catch (e) {
        // leave the line empty rather than claiming "never reviewed"
        this.fetched = null;
      }
    },
  },
};
</script>
